<template>
  <div class="hub-outer">
    <div class="hub-frame" :style="{ backgroundImage: `url(${imgBack})` }">
      <!-- Top row: EPHOTO + SUPERSTUDIO SET -->
      <div class="top-row">
        <div class="btn-wrapper" @click="openLink(linkEphoto)">
          <img :src="imgEphoto" alt="EPHOTO" />
        </div>
        <div class="btn-wrapper" @click="openLink(linkSuperstudio)">
          <img :src="imgSet" alt="SUPERSTUDIO SET" />
        </div>
      </div>

      <!-- Center: FLA MUSEUM experience -->
      <div class="center-row">
        <div class="btn-wrapper" @click="openLink(linkFlaMuseum)">
          <img :src="imgFla" alt="FLA MUSEUM experience" />
        </div>
      </div>
    </div>

    <!-- Iframe overlay fullscreen -->
    <div v-if="iframeUrl" class="iframe-overlay">
      <iframe
        :src="iframeUrl"
        class="iframe-full"
        @error="onIframeError"
      ></iframe>
      <button class="iframe-close" @click="closeIframe">✕</button>
      <div class="iframe-timer">
        <div class="timer-bar" :style="{ animationDuration: timerDuration + 'ms' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinksHub',
  data() {
    return {
      linkEphoto: process.env.VUE_APP_LINK_EPHOTO || '#',
      linkSuperstudio: process.env.VUE_APP_LINK_SUPERSTUDIO || '#',
      linkFlaMuseum: process.env.VUE_APP_LINK_FLA_MUSEUM || '#',
      imgEphoto: require('@/assets/btn_ephoto.png'),
      imgSet: require('@/assets/btn_set.png'),
      imgFla: require('@/assets/btn_fla.png'),
      imgBack: require('@/assets/back_hub.png'),
      iframeUrl: null,
      inactivityTimer: null,
      timerDuration: 300000 // 5 minuti in ms
    };
  },
  methods: {
    openLink(url) {
      if (!url || url === '#') return;
      this.iframeUrl = url;
      this.startInactivityTimer();
    },
    closeIframe() {
      this.iframeUrl = null;
      this.clearInactivityTimer();
    },
    startInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.closeIframe();
      }, this.timerDuration);
    },
    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },
    onIframeError() {
      // Fallback: se l'iframe viene bloccato, apri nella stessa finestra
      // e torna all'hub dopo 5 minuti
      const url = this.iframeUrl;
      this.closeIframe();
      window.location.href = url;
    }
  },
  beforeUnmount() {
    this.clearInactivityTimer();
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

/* ── Outer: sfondo nero fullscreen ───────────────────── */
.hub-outer {
  position: fixed;
  inset: 0;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: 'Arial', sans-serif;
}

/* ── Frame portrait ───────────────────────────────────── */
.hub-frame {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 18vh;
  gap: 5vh;
  overflow: visible;
}

/* ── Top row: EPHOTO + SUPERSTUDIO SET affiancati ────── */
.top-row {
  display: flex;
  gap: 4vw;
  justify-content: center;
  width: 58vw;
  padding-top: 1.5vh;
  overflow: visible;
}

/* ── Card FLA MUSEUM centrata ─────────────────────────── */
.center-row {
  display: flex;
  justify-content: center;
  width: 46vw;
}

/* ── Button wrapper ───────────────────────────────────── */
.btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.25s ease, filter 0.25s ease;
  flex: 1;
  user-select: none;
}

.center-row .btn-wrapper {
  flex: none;
  width: 100%;
}

.btn-wrapper:hover {
  transform: scale(1.04);
  filter: brightness(1.08);
}

.btn-wrapper:active {
  transform: scale(0.97);
}

/* Pill buttons: max 9vh di altezza */
.top-row .btn-wrapper img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 7vh;
  object-fit: contain;
}

/* Card FLA: max 30vh di altezza */
.center-row .btn-wrapper img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 24vh;
  object-fit: contain;
}

/* ── Iframe overlay ───────────────────────────────────── */
.iframe-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: #000;
}

.iframe-full {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* ── Pulsante chiudi ──────────────────────────────────── */
.iframe-close {
  position: absolute;
  top: 0.3vh;
  right: 0.3vw;
  z-index: 10001;
  width: clamp(28px, 3.5vw, 44px);
  height: clamp(28px, 3.5vw, 44px);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  font-size: clamp(0.7rem, 1.5vw, 1.1rem);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.2s ease;
  backdrop-filter: blur(6px);
}

.iframe-close:hover {
  background: rgba(255, 60, 60, 0.75);
  transform: scale(1.1);
}

.iframe-close:active {
  transform: scale(0.95);
}

/* ── Barra timer in basso ─────────────────────────────── */
.iframe-timer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  z-index: 10001;
}

.timer-bar {
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  transform-origin: left;
  animation: countdown linear 1 forwards;
}

@keyframes countdown {
  from { transform: scaleX(1); }
  to   { transform: scaleX(0); }
}
</style>
